const breakpoint = 768;
// 関数定義 **********************************************************************
const fadeInUp = () => {
  let fadeInTargets = document.querySelectorAll('.js-fadeInUp');
  fadeInTargets.forEach((target) => {
    gsap.fromTo(
      target,
      {
        y: 30,
        x: 0,
        autoAlpha: 0,
      },
      {
        y: 0,
        x: 0,
        autoAlpha: 1,
        stagger: 0.1,
        duration: 0.8,
        ease: 'power1.inOut',
        scrollTrigger: {
          trigger: target,
          start: 'top 90%',
        },
      },
    );
  });
};
const fadeIn = () => {
  let OnlyfadeInTargets = document.querySelectorAll('.js-fadeIn');
  OnlyfadeInTargets.forEach((target) => {
    gsap.fromTo(
      target,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        duration: 0.8,
        stagger: 0.1,
        ease: 'power1.inOut',
        scrollTrigger: {
          trigger: target,
          start: 'top 80%',
        },
      },
    );
  });
};

/**
 * スマホでアドレスバー表示/非表示によりビューポート高さが変わったときに
 * ScrollTrigger のトリガー位置を再計算する。
 * 再計算しないと、下の方のセクションほど「画面トップより上に行ってからやっと出現する」現象が起きる。
 */
const setupScrollTriggerRefreshOnViewportChange = () => {
  let lastHeight = window.innerHeight;
  let refreshTid = null;
  const scheduleRefresh = () => {
    if (refreshTid) clearTimeout(refreshTid);
    refreshTid = setTimeout(() => {
      refreshTid = null;
      ScrollTrigger.refresh();
    }, 150);
  };
  const onViewportChange = () => {
    const h = window.innerHeight;
    if (h !== lastHeight) {
      lastHeight = h;
      scheduleRefresh();
    }
  };
  if (typeof window.visualViewport !== 'undefined') {
    window.visualViewport.addEventListener('resize', onViewportChange);
    window.visualViewport.addEventListener('scroll', onViewportChange);
  }
  window.addEventListener('resize', onViewportChange);
};

// 実行 **********************************************************************
document.addEventListener('DOMContentLoaded', function () {
  gsap.registerPlugin(ScrollTrigger);
  setupScrollTriggerRefreshOnViewportChange();
  const mm = gsap.matchMedia();
  // SPの時
  mm.add(`screen and (max-width: ${breakpoint - 1}px)`, () => {
    fadeIn();
    fadeInUp();
  });
  // PCの時
  mm.add(`screen and (min-width: ${breakpoint}px)`, () => {
    fadeIn();
    fadeInUp();
  });
});
